import { render, staticRenderFns } from "./AiManualDevice.vue?vue&type=template&id=70556367&scoped=true&"
import script from "./AiManualDevice.vue?vue&type=script&lang=js&"
export * from "./AiManualDevice.vue?vue&type=script&lang=js&"
import style0 from "./AiManualDevice.vue?vue&type=style&index=0&id=70556367&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70556367",
  null
  
)

export default component.exports